/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { clearValidateRecaptcha } from 'actions/reCaptcha'
import Button from 'components/button'
import theme from 'components/theme'
import { sublosErrors as e2eClasses } from 'constants/e2eClasses'
import { mapMediaType } from 'selectors/mediaType'
import { getValidateRecaptchaError } from 'selectors/reCaptcha'

import {
  ErrorButtonWrapper,
  ErrorMessage,
  ErrorTextWrapper,
  ErrorTitle,
  ErrorWrapper
} from './styled'

const RECAPTCHA_ID = 'recaptcha-error-button'

const RecaptchaErrorMessage = ({ recaptchaError, clearValidateRecaptcha }) => {
  const { t } = useTranslation()
  const [disableReloadButton, setDisableReloadButton] = useState()

  useEffect(() => {
    if (recaptchaError) {
      showError()
    }
  }, [recaptchaError])

  const validateInputClass = (element, i) =>
    element.classList[i].includes('input__') ||
    element.classList[i].includes('react-select__control')

  const disableAction = element => {
    element.style.pointerEvents = 'none'
    element.parentElement.style.cursor = 'no-drop'
  }

  const disableLink = element => {
    element.style.color = theme.colors.gallery
    disableAction(element)
  }

  const disableField = element => {
    element.style.backgroundColor = theme.colors.gallery
    disableAction(element)
  }

  const disableButton = element => {
    if (element.id === RECAPTCHA_ID) return
    disableField(element)
  }

  const recursivelyGetTagInput = element => {
    if (element?.classList) {
      for (let i = 0, len = element.classList?.length; i < len; ++i) {
        element.style.backgroundColor = theme.colors.gallery

        if (validateInputClass(element, i)) {
          disableAction(element)
          element.disabled = true
          return element
        }
      }
    }

    element.parentElement && recursivelyGetTagInput(element.parentElement)
  }

  const recursivelyDisableFormFields = element => {
    if (element.children?.length) {
      for (let i = 0, len = element.children?.length; i < len; ++i) {
        if (element.children[i]) {
          switch (element.children[i].tagName) {
            case 'INPUT':
              recursivelyGetTagInput(element.children[i])
              continue
            case 'BUTTON':
              disableButton(element.children[i])
              continue
            case 'TEXTAREA':
              disableField(element.children[i])
              continue
            case 'A':
              disableLink(element.children[i])
              continue
            default:
              recursivelyDisableFormFields(element.children[i])
              continue
          }
        }
      }
    }

    return
  }

  const showError = () => {
    const modal = window.document.getElementById('RECAPTCHA-MODAL-ERROR')
    const form = window.document.getElementsByTagName('form')

    if (modal) {
      modal.style.display = 'flex'
    }

    if (form) {
      for (let i = 0, len = form?.length; i < len; ++i) {
        recursivelyDisableFormFields(form[i])
      }
    }

    clearValidateRecaptcha()
  }

  const hideError = () => {
    setDisableReloadButton(true)
    location?.reload()
  }

  return (
    <ErrorWrapper id="RECAPTCHA-MODAL-ERROR">
      <ErrorTextWrapper>
        <ErrorTitle
          dangerouslySetInnerHTML={{
            __html: t('general.re-captcha-title-error')
          }}
        />
        <ErrorMessage
          dangerouslySetInnerHTML={{
            __html: t('general.re-captcha-description-error')
          }}
        />
      </ErrorTextWrapper>
      <ErrorButtonWrapper>
        <Button
          id={RECAPTCHA_ID}
          onClick={hideError}
          disabled={disableReloadButton}
          padding={'10px 49px'}
          name={e2eClasses.button}
        >
          {t('general.re-captcha-reload-button')}
        </Button>
      </ErrorButtonWrapper>
    </ErrorWrapper>
  )
}

const mapStateToProps = state => ({
  mediaType: mapMediaType(state),
  recaptchaError: getValidateRecaptchaError(state)
})

const mapDispatchToProps = {
  clearValidateRecaptcha
}

export default connect(mapStateToProps, mapDispatchToProps)(RecaptchaErrorMessage)

RecaptchaErrorMessage.propTypes = {
  changeModalState: PropTypes.func,
  recaptchaError: PropTypes.bool,
  mediaType: PropTypes.string
}
